<script setup lang="ts">
import { useId } from 'vue'

defineProps({
  label: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  errorMessage: String,
})

const modelValue = defineModel<boolean>({ default: false })
const inputId = useId()
</script>

<template>
  <div class="form-control w-full">
    <div class="label flex justify-start gap-4 items-center py-0">
      <label
        :for="inputId"
        class="label-text font-semibold cursor-pointer shrink-0"
      >
        {{ label }} <span v-if="required" class="text-red-500">*</span>
      </label>
      <input
        :id="inputId"
        type="checkbox"
        class="toggle toggle-primary toggle-sm shrink-0"
        :class="{ 'border-red-500': errorMessage }"
        v-model="modelValue"
        :disabled="disabled"
      />
    </div>
    <span v-if="errorMessage" class="text-red-500 text-sm ml-1">{{ errorMessage }}</span>
  </div>
</template>
